import { JSX } from "react";
import { TooltipWrapper } from "@app/shared";

const QuestProprietaryDataIcon = (): JSX.Element => {
  return (
    <TooltipWrapper
      containerClassName="ml-1"
      text="Quest Proprietary Data"
    >
      <img className="d-block" src={`${window.customUIBaseUrl}/images/green-check.svg`} alt="" />
    </TooltipWrapper>
  );
}

export default QuestProprietaryDataIcon;
